import { useEffect, useState } from "react";
import { TableColumnsType, Switch, message, Row, Col } from "antd";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import { paths, permissions } from "@/router";
import Button from "@components/Button";
import Table from "@components/Table";
import {
  useFetchTomUsersQuery,
  useSubAdminListMutation,
  useToggleSubAdminMutation,
} from "@/services/sub.admin";
import { ICombineReducerProps } from "@/store";
import { ISubAdminItem, ISubAdminReducer } from "@types";
import { ErrorServices } from "@/services";
import { checkPermission } from "@/utils";
import AddTomUser from "../SubAdminsCreate/SubAdminCreateModal";
import { GoPencil } from "react-icons/go";

const SubAdminsList = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [switchStates, setSwitchStates] = useState<Record<string, boolean>>({});

  const {
    data,
    isLoading: loader,
    refetch,
  } = useFetchTomUsersQuery({
    page,
    page_size: pageSize,
  });
  const { data: users, pagination } = data || {};

  useEffect(() => {
    if (!users) return;

    setSwitchStates(prev => {
      const updated = { ...prev };

      users.forEach((user: any) => {
        // Only initialize values we don't already control locally
        if (updated[user.id] === undefined) {
          updated[user.id] = user.is_active;
        }
      });

      return updated;
    });
  }, [users]);

  const subAdminReducer: ISubAdminReducer = useSelector(
    (state: ICombineReducerProps) => state.subAdmin
  );
  const history = useHistory();
  const [getSubAdminList, { isLoading }] = useSubAdminListMutation();
  const [toggleSubAdmin] = useToggleSubAdminMutation();

  const columns: TableColumnsType<ISubAdminItem> = [
    {
      title: "NAME",
      key: "name",
      width: 130,
      render: ({ first_name, last_name }) => (
        <span>
          {first_name} {last_name}
        </span>
      ),
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
      width: 180,
    },
    {
      title: "PHONE NO",
      key: "phone_number",
      width: 130,
      render: ({ phone_number, phone_code }) => (
        <span>
          +{phone_code}
          {phone_number}
        </span>
      ),
    },
    ...((!checkPermission(permissions.ENABLE_DISABLE_TOM_USER)
      ? []
      : [
          {
            title: "Active/Inactive",
            width: 130,
            render: ({ id, first_name, last_name, is_active }: any) => {
              return (
                <Switch
                  checked={switchStates[id] ?? is_active}
                  onChange={(checked: boolean) =>
                    toggleSubAdminFromApi(
                      id,
                      `${first_name} ${last_name}`,
                      checked,
                      switchStates[id] ?? is_active
                    )
                  }
                />
              );
            },
          },
        ]) as any),
    ...((!checkPermission(permissions.UPDATE_TOM_USER)
      ? []
      : [
          {
            title: "Actions",
            key: "action",
            width: 160,
            align: "center",
            render: ({ id }: any) => (
              <div className="flex items-center justify-center">
                <div
                  onClick={() => history.push(`/tom-users/edit/${id}`)}
                  className="table__action__btn table__action__btn--client"
                >
                  <GoPencil className="text-white mr-1 text-sm" /> Edit
                </div>
              </div>
            ),
          },
        ]) as any),
  ];

  useEffect(() => {
    getAdminListFromApi(page);
  }, [page]);

  const getAdminListFromApi = async (page: number) => {
    try {
      await getSubAdminList(page).unwrap();
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const toggleSubAdminFromApi = async (
    id: string,
    name: string,
    is_active: boolean,
    previousState: boolean
  ) => {
    const isUserActive = is_active ? "active" : "inactive";

    // Move switch immediately
    setSwitchStates(prev => ({
      ...prev,
      [id]: is_active,
    }));

    try {
      await toggleSubAdmin({ id, is_active }).unwrap();

      await getAdminListFromApi(page);
      await refetch();

      // Keep the optimistic state in sync with the successful response
      setSwitchStates(prev => ({
        ...prev,
        [id]: is_active,
      }));

      message.success(`${name} is now an ${isUserActive} user`);
    } catch (err: any) {
      // Revert only on failure
      setSwitchStates(prev => ({
        ...prev,
        [id]: previousState,
      }));

      ErrorServices(err);
    }
  };

  useEffect(() => {
    refetch();
  }, []);
  return (
    <>
      <AddTomUser
        isVisible={isAddModalVisible}
        setIsVisible={setIsAddModalVisible}
        refetch={refetch}
      />

      <div className="bg-white p-4 sm:p-5">
        {/* <div className="appTitle text-base font-[500] mx-5">Tom-Users</div> */}
        <div className="jobCreationBar  sticky top-0 z-10 bg-themeCore px-14 py-6 rounded-lg flex justify-between items-center mb-7">
          <div className="title text-white font-[500] text-3xl uppercase">
            Tom-Users
          </div>
          {checkPermission(permissions.CREATE_TOM_USER) && (
            <>
              {/* <Button
            variant="buttonWhite"
            onClick={() => history.push(paths.admin.settings.tom_users.create)}
          >
            Create Tom User
          </Button> */}
              <Button
                variant="buttonWhite"
                onClick={() => setIsAddModalVisible(true)}
              >
                Create Tom User
              </Button>
            </>
          )}
        </div>

        <div className="jobCreationListing bg-white py-2 rounded-lg">
          <Table
            // data={subAdminReducer?.list}
            // isLoading={isLoading}
            // columns={columns}
            // pagination={true}
            // count={subAdminReducer.pagination?.count}
            // onChangePage={setPage}
            // page={page}
            data={users}
            isLoading={isLoading}
            columns={columns}
            pagination={true}
            count={pagination?.count}
            onChangePage={setPage}
            onPageSizeChange={setPageSize}
            page={page}
          />
        </div>
      </div>
    </>
  );
};

export default SubAdminsList;
